import { IRootState } from '../../app/store';

export const selectReferentialAccessDetails = (state: IRootState) =>
    state.referentialAccess.referentialAccessDetails;

export const selectClientId = (state: IRootState) =>
    state.referentialAccess.clientDetails.id;

export const selectReferentialClientAuthorizedForSkill = (state: IRootState) =>
    state.referentialAccess.clientDetails.hasSkillAuthorization;

export const selectIsWhitelistedIp = (state: IRootState) =>
    state.referentialAccess.isWhitelisted;

export const selectEcrId = (state: IRootState) => state.referentialAccess.ecrId;

export const selectReferentialAccessAsyncStatus = (state: IRootState) =>
    state.referentialAccess.asyncStatusReferential;

export const selectIsIpWhitelistedAsyncStatus = (state: IRootState) =>
    state.referentialAccess.asyncStatusWhitelisted;

export const selectClientIdByEcrIdAsyncStatus = (state: IRootState) =>
    state.referentialAccess.asyncStatus;
